import * as React from 'react';
export const benchSvg = React.forwardRef(function benchSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#2F3034',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M7.8 7.8v8.14a8.14 8.14 0 0 0 16.27 0V7.8H7.81zm8.14 18.08A9.95 9.95 0 0 1 6 15.94V6h19.88v9.94a9.95 9.95 0 0 1-9.94 9.94zm4.52-13.86h-9.04v1.81h1.24l-.63 5h1.82l.63-5h2.92l.63 5h1.82l-.63-5h1.24v-1.8z',
      }),
    ),
  );
});
benchSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var bench = {
  category: 'brand',
  colorable: false,
  name: 'bench',
  svg: benchSvg,
};
